<template>
    <div class="article-details">
        <router-view></router-view>

        <div class="article-details__card">
            <div class="article-details__top">
                <icon-button @click="closeInfo">close</icon-button>
            </div>

            <div class="article-details__main">
                <div class="article-details__left" v-if="artDetails.image"
                     @click="openPicture(apiurl+'/image'+artDetails.image)">

                    <img class="article-details__image" :src="apiurl+'/image'+artDetails.image+'?'+nowTime" alt="">
                </div>

                <div class="article-details__right">
                    <div class="article-details__number">
                        <div>{{artDetails.artnum}}</div>
                        <div class="spacer"></div>
                        <div v-if="artDetails.greater100 === 1" class="greendot">CHF</div>
                        <div v-if="artDetails.MHD === 1" class="MHD">MHD</div>
                    </div>

                    <div class="article-details__actions">
                        <default-button v-if="userLev.indexOf('T') < 0 && showAbbuchen"
                                        class="article-details__action"
                                        @click="openAbbuchen"
                        >
                            Abbuchen
                        </default-button>

                        <default-button v-if="userLev.indexOf('6') > -1"
                                        class="article-details__action"
                                        @click="print"
                        >
                            Karte ausdrucken
                        </default-button>
                    </div>

                    <hr class="article-details__separator">

                    <div class="infotext">
                        {{artDetails.shorttxt}}
                        <hr class="article-details__separator">
                        <div v-if="artDetails.info !=null" v-html="artDetails.info.replace(/\n/g,'<br>')"></div>
                        <hr class="article-details__separator" v-if="artDetails.notiz !== ''">
                        <div v-if="artDetails.notiz !=null" v-html="artDetails.notiz.replace(/\n/g,'<br>')"></div>
                    </div>

                    <hr class="article-details__separator">

                    Ort: {{artDetails.ort}}<br>
                    Bestand: {{artDetails.max}}<br>
                    Einheit: {{artDetails.mengeneinheit}}<br>
                    Stk / Einheit: {{artDetails.StkProEinheit}}<br>
                    Kapazität: {{artDetails.kapa}}<br>

                    <hr class="article-details__separator" v-if="artDetails.otherLager !== ''">

                    <!-- <div class="artDetailsAbstand" v-if="artDetails.otherLager !== ''">
                        Angaben ohne Gewähr. Bitte im SAP nachschauen
                    </div> -->
                    <table class="detailStaoList">
                        <!-- <div v-if="item.besMax > 0"> -->
                            <tr class="otherStaoInfo" v-for="item in artDetails.otherLager"
                                                    :key="item.id">
                                <td class="otherStaoInfoName">
                                    {{item.name}}:
                                </td>
                                <td class="otherStaoInfoInfo" v-if="item.diag">
                                    {{item.lagerOrt}} || {{item.besMax}} {{item.mengeneinheit}}
                                </td>
                                <td class="otherStaoInfoInfoSmall" v-if="!item.diag">
                                    Bestand im SAP nachschauen
                                </td>
                            </tr>
                        <!-- </div> -->
                    </table>

                    <div class="artDetailsAbstand"></div>
                    <hr class="article-details__separator">
                    <div class="detailtraindiv"
                         v-for="item in artTrains"
                         :key="item.id"
                    >
                        {{item.train}}
                    </div>

                    <hr class="article-details__separator">

                    <default-button v-if="userCanEdit"
                                    :variations="['full-width']"
                                    @click="openEdit()"
                    >
                        Bearbeiten
                    </default-button>
                    <default-button v-if="!userCanEdit"
                                    @click="sendMail()"
                    >
                        Änderung beantragen
                    </default-button>
                </div>
            </div>
        </div>

        <!-- ==================================================================== -->

        <div id="htmlHolder" hidden>
            <div style="display:flex; flex-direction:row; width:800px; height:400px; overflow:hidden">

                <div style="display:flex; flex-direction:column; flex:1; padding:0.375rem; border:0.375rem solid black;">
                    <div style="display:flex; flex-direction:row;">

                        <div style="display:flex; flex-direction:column; flex:1">

                            <div style="font-weight: bold; font-size: 1.25rem">Artikelnummer</div>
                            <div style="font-size: 2rem">{{artDetails.artnum}}</div>

                            <div style="font-weight: bold; font-size: 1.25rem">Fahrzeuge</div>
                            <div style="font-size: 1rem">{{artTrainsTxt}}</div>

                        </div>
                        <div
                            style="display:flex; flex-direction:column; flex:1; justify-content:center; align-items:center;">

                            <img class="four-oh-four__image" :src="img" style="object-fit:contain">

                        </div>
                    </div>
                    <div style="display:flex; flex-direction:row;">
                        <div style="display:flex; flex-direction:column;">

                            <div style="font-weight: bold; font-size: 1.25rem">Bezeichnung</div>
                            <div style="font-size: 1.25rem">{{artDetails.shorttxt}}</div>

                        </div>
                        <div style="display:flex; flex-direction:column; width:3rem;">

                            <div style="display:flex; align-items: center; justify-content:center; flex:1">
                                <img class="four-oh-four__image" src="/images/maticons/i.png" style="object-fit:contain">
                            </div>
                            <div v-if="artDetails.greater100 > 0"
                                 style="display:flex; align-items: center; justify-content:center; flex:1">
                                <img class="four-oh-four__image" src="/images/maticons/punkt.png"
                                     style="object-fit:contain">

                            </div>
                            <div v-if="artDetails.MHD > 0"
                                 style="display:flex; align-items: center; justify-content:center; flex:1">
                                <img class="four-oh-four__image" src="/images/maticons/mhd.png" style="object-fit:contain">
                            </div>

                        </div>
                    </div>

                </div>
                <!-- ================= -->
                <div style="display:flex; flex-direction:column; flex:1; padding:0.375rem; border: 0.375rem solid black;">
                    <div style="display:flex; flex-direction:row;">

                        <div style="display:flex; flex-direction:column; flex:1">

                            <div style="font-weight: bold; font-size: 1.25rem">Artikelnummer</div>
                            <div style="font-size: 2rem">{{artDetails.artnum}}</div>

                        </div>
                        <div
                            style="display:flex; flex-direction:column; flex:1; justify-content:center; align-items:center;">

                            <img class="four-oh-four__image" :src="img" style="object-fit:contain">

                        </div>
                    </div>
                    <div style="font-weight: bold; font-size: 2.5rem; color:red; width:100%; text-align: center;">
                        NULLBESTAND
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
import http from '../../http/http';
import qrcode from 'qrcode';

import IconButton from '../common/icon-button';
import DefaultButton from '../common/default-button';

export default {
    components: {
        DefaultButton,
        IconButton
    },
    data() {
        return {
            nowTime: '',
            img: '',
            showAbbuchen: false
        }
    },
    props: {
        artId: {
            type: String,
            default: '1'
        },
        stao: {
            type: String,
            default: '1'
        }
    },
    computed: {
        artDetails() {

            let artStuff = this.$store.getters['fotodatenbank/artDetails'];

            if (artStuff.ort === '') {
                this.showAbbuchen = false;
            } else {
                this.showAbbuchen = true;
            }

            return artStuff;
        },
        artTrains() {
            return this.$store.getters['fotodatenbank/artTrains'];
        },
        userLev() {
            return this.$store.getters['user/autLev'];
        },
        apiurl() {
            return http.defaults.baseURL;
        },
        artTrainsTxt() {
            return this.$store.getters['fotodatenbank/artTrainsTxt'];
        },
        lagerCheff() {
            return this.$store.getters['fotodatenbank/lagerCheff'];
        },
        userCanEdit() {
            return this.userLev.indexOf('3') > -1;
        }
    },
    watch: {},
    methods: {
        closeInfo() {
            const path = this.$route.fullPath;

            if (path[path.length - 1] === '/') {
                this.$router.go(-1);
            } else {
                this.$router.push('/fotodatenbank');
            }
        },

        openPicture(url) {
            const win = window.open(url, '_blank');
            win.focus();
        },

        openEdit() {
            const path = this.$route.fullPath;

            if (path[path.length - 1] === '/') {
                this.$router.push('editart');
            } else {
                this.$router.push(path + '/editart');
            }
        },
        openAbbuchen() {
            const path = this.$route.fullPath;

            if (path[path.length - 1] === '/') {
                this.$router.push('abbuchen');
            } else {
                this.$router.push(path + '/abbuchen');
            }
        },
        print() {
            const printWindow = window.open('', '', 'height=500, width=1050');
            printWindow.document.write(document.getElementById('htmlHolder').innerHTML);
            printWindow.document.close();
            printWindow.print();
        },
        sendMail() {
            // const mailAdresses  ='';

            // for(const i=0; i<this.lagerCheff.length;i++){
            //     mailAdresses = mailAdresses + this.lagerCheff[i].email +';';
            // }

            const mailQuery = 'mailto:' + this.lagerCheff[0].email + '?' +
                    'subject=LEA%20Lageränderung%20Art%20' + this.artDetails.artnum + '&' +
                    'body=' +
                    'Hallo%20' + this.lagerCheff[0].fname + '%20%0D%0A' +
                    'Ich%20schlage%20eine%20Änderung%20zum%20Artikel%20' + this.artDetails.artnum + '%20vor:%0D%0A%20';

            console.log(mailQuery);

            const wind = window.open(mailQuery, '_blank');
            wind.focus();
        }

    },
    created() {
        this.nowTime = (new Date()).getTime();
        this.$store.dispatch('fotodatenbank/openDetails', { id: this.artId, stao: this.stao });
        this.$store.dispatch('fotodatenbank/getLagerCheff', { stao: this.stao });

    },
    mounted() {
        const data = 'https://lea.services/fotodatenbank/artdetails/' + this.artId + '/' + this.stao;

        qrcode.toDataURL(data)
            .then(url => {
                this.img = url;
            })
            .catch(err => {
                console.error(err)
            })
    }
}
</script>

<style scoped lang="scss">

    .detailStaoList{
        //width:100%;
        border-collapse: collapse;
    }

    .otherStaoInfoName {
        text-align: right;
        padding-right: 4px;

    }

    .otherStaoInfoInfoSmall {
        text-align: left;
        font-size: 15px;
        text-align: center;
    }

    .otherStaoInfoInfo {
        text-align: left;
    }

    .article-details {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9999;
        width: 100%;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .article-details__card {
        position: relative;
        display: flex;
        flex-direction: column;
        max-width: 100%;
        max-height: 100vh;
        background-color: $color-white;
        @include default-shadow;
        padding: 1rem;
        overflow-y: auto;
    }

    .article-details__top {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-bottom: 0.5rem;

        @include large {
            position: absolute;
            right: 1rem;
            top: 1rem;
        }
    }

    .article-details__separator {
        border: 0;
        padding: 1px;
        clear: both;
        display: block;
        background-color: $color-black;
        height: 0.125rem;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .artDetailsAbstand {
        font-size: 1rem;
        margin-top: 0.625rem;
        margin-bottom: 0.625rem;
    }

    .article-details__main {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .article-details__right {
        @include extra-large {
            margin-top: 2.5rem;
            max-width: 31rem;
            min-width: 31rem;
        }
    }

    .article-details__left {
        display: inline-block;
        margin-bottom: 1rem;

        @include extra-large {
            padding-right: 1rem;
        }
    }

    .article-details__image {
        max-width: 100%;
    }

    .article-details__number {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 2rem;
        margin-bottom: 1rem;
    }

    .spacer {
        flex: 1;
    }

    .greendot {
        //border-radius: 50%;
        background-color: $color-green;
        height: 2rem;
        font-size: 1rem;
        line-height: 2rem;
        padding-left: 0.125rem;
        padding-right: 0.125rem;
    }

    .MHD {
        background-color: #cc6600;
        height: 2rem;
        font-size: 1rem;
        line-height: 2rem;
        padding-left: 0.125rem;
        padding-right: 0.125rem;
    }

    .article-details__actions {
        display: flex;
        flex-direction: row;
    }

    .article-details__action {
        flex-grow: 1;

        &:first-child {
            margin-right: 0.5rem;
        }

        &:last-child {
            margin-left: 0.5rem;
        }
    }

    .infotext {
        width: 100%;
    }

    @include medium {
        .article-details__card {
            width: 31rem;
        }

    }

    @include extra-large {
        .article-details__card {
            width: auto;
            max-width: 90%;
        }

        .article-details__main {
            flex-direction: row;
            font-size: 1.5rem;
        }

        .article-details__image {
            max-width: 1000px;
            max-height: 1000px;

        }

        .article-details__number {
            font-size: 2.5rem;
        }

    }

</style>
